export default __webpack_public_path__ + "static/media/KNX.358256ab.svg";